const productsData = [
  {
    id: 'sponsorship',
    title: 'Finanzas con Propósito',
    product: 'Sponsorship Premium - Punto de Fe',
    investment: '$80 / mes',
    impacts: [
      'Patrocinio exclusivo del bloque "Consejos para el Progreso".',
      'Menciones de apertura y cierre + logo en pantalla.',
      'Vinculación emocional de la marca con la paz mental y la seguridad familiar.',
    ],
  },
  {
    id: 'ugc',
    title: 'UGC Lab: El Test de Agilidad',
    product: 'Plan Mensual UGC (4 videos)',
    investment: '$100 / mes',
    subtitle: '1 video semanal (4 al mes)',
    impacts: [
      'Video estilo Reel/TikTok: operación real (pagar con divisas, abrir cuenta desde la App) en menos de 60 segundos.',
      'Demostrar en tiempo real que la tecnología de Bancaribe funciona y es fácil.',
      'Romper la barrera del miedo tecnológico mediante la prueba social.',
    ],
  },
  {
    id: 'glosario',
    title: 'El Glosario del Progreso',
    product: 'Branded Content (Autoridad SEO)',
    investment: '$50 / mes',
    impacts: [
      '1 artículo editorial mensual en tnonetwork.com (Sección TNO Digest).',
      'Temática: educación financiera y ciberseguridad (ej. "Cómo proteger tus ahorros digitales").',
      'Incluye backlinks directos a la web de Bancaribe. Construcción de reputación digital en Google.',
    ],
  },
  {
    id: 'flash-rotativa',
    title: 'Flash Mentions + Plan Rotativa Network 24/7',
    product: 'Menciones ráfaga y Plan Rotativa TNO',
    investment: '$250 / mes',
    impacts: [
      '2 menciones de 15 segundos por semana fuera del programa ancla.',
      'Notificar sobre nuevas funciones de la App o disponibilidad de servicios en taquilla.',
      'Dinamismo informativo y recordación de actualizaciones.',
      'Presencia constante en radio y streaming visual durante toda la programación.',
      'Dominio del Top of Mind en todo el ecosistema TNO.',
      'Recordación de marca masiva.',
    ],
  },
];

export default productsData;
